import { notification } from '../../../../utility/notification/notification.service';
import {
  basePatchQuery,
  basePostQuery,
  createGuest,
  createTableReservation,
} from '../../../../utility/sb-api/sb-api.service';
import {
  closeModalSafely as closeModalSafelyBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';
import retry from 'async-retry';

export const closeModalSafely = closeModalSafelyBase;

export const handleTableQuerySubmit = (
  event,
  errors,
  values,
  targetReservation,
  setTargetReservation,
  setCurrentStep,
  setSlots,
  setIsSubmitting,
  setWebSocketToken,
  me,
  intl,
  fetchOnAuthenticated,
) => {
  if (errors.length === 0) {
    setIsSubmitting(true);

    const data = { ...targetReservation, ...values };

    setTargetReservation(data); // update for further actions

    return (me
      ? Promise.resolve()
      : createGuest({ locale: intl?.locale.split('-')[0] }, setWebSocketToken).then(() =>
          fetchOnAuthenticated(),
        )
    )
      .then(() =>
        basePostQuery('table-reservations/table-query', data, null, null, null),
      )
      .then((table) => {
        setTargetReservation({
          ...data,
          tableId: table.id,
          table: table,
        });

        // to be able to show the search animation
        setTimeout(() => {
          setIsSubmitting(false);
          setCurrentStep(2);
        }, 3000);

        return table;
      })
      .catch((error) => {
        // eslint-disable-next-line default-case
        switch (error?.response?.data?.error) {
          case 'TABLE_RESERVATION_ALREADY_EXISTS':
          case 'MULTIPLE_TABLE_RESERVATIONS_FORBIDDEN':
            notification('error', 'tableReservationAlreadyExistsMessage');
            setIsSubmitting(false);
            setCurrentStep(0);
            return;
          case 'TIME_SLOT_OUT_OF_SERVICE_TIMES':
            notification('error', 'tableReservationOutOfServiceTimesMessage');
            setIsSubmitting(false);
            setCurrentStep(0);
            return;
        }

        // if no table was found, do a slots query to show alternatives
        if (
          error?.response?.data?.statusCode ===
          error?.response?.data?.statusCode
        ) {
          return basePostQuery(
            'table-reservations/slots-query',
            data,
            null,
            null,
            null,
          )
            .then((slots) => {
              setSlots(slots);

              // to be able to show the search animation
              setTimeout(() => {
                setIsSubmitting(false);
                setCurrentStep(1);
              }, 2000);
            })
            .catch((error) => {
              setIsSubmitting(false);
              if (
                error?.response.data.error === 'TABLE_CAPACITY_NOT_AVAILABLE' ||
                error?.response.data.error === 'RESERVATION_SLOTS_NOT_AVAILABLE'
              ) {
                notification('error', 'tableReservationSlotsNotAvailableError');
              }
            });
        } else {
          notification('error', 'requestUnknownError');
          setIsSubmitting(false);
          setCurrentStep(0);
          console.error(error);
        }
      });
  }
};

export const handleCreateTableReservation = async (
  targetReservation,
  setTargetReservation,
  setIsSubmitting,
  closeModal,
  onSubmit,
) => {
  setIsSubmitting(true);

  // try to create a reservation for each table, until one succeeds.
  const tablesToIterate = Array.isArray(targetReservation.tables)
    ? targetReservation.tables
    : [targetReservation.table];

  for (const table of tablesToIterate) {
    try {
      const tableReservation = await createTableReservation({
        ...targetReservation,
        tableId: table.id,
        storeId: undefined,
        tables: undefined,
        duration: undefined,
      });

      setTargetReservation(tableReservation);
      onSubmit();
      setIsSubmitting(false);
      return true;
    } catch (error) {
      if (
        error?.response.data.error === 'TABLE_CAPACITY_NOT_AVAILABLE' ||
        error?.response.data.error === 'RESERVATION_SLOTS_NOT_AVAILABLE'
      ) {
        notification('error', 'tableReservationSlotsNotAvailableError');
        setIsSubmitting(false);
        closeModal();
        return true;
      } else {
        console.log(`Table "${table.id}" not available, retrying...`);
      }
    }
  }

  // If the loop completes without returning, it means no reservation was successful.
  notification('error', 'tableReservationSlotsNotAvailableError');
  setIsSubmitting(false);
  closeModal();
};
